export default "__VITE_ASSET__9zkIUoFa__"